
import PropTypes from 'prop-types'
import WarningIcon from '@mui/icons-material/Warning'
import { Typography } from '@mui/material'
import { createTheme, responsiveFontSizes, ThemeProvider } from '@mui/material/styles'
import { themeV5 } from 'theme/v5'

const Ribbon = ({ text, backgroundColor, customChildren }) => {
  let theme = createTheme()
  theme = responsiveFontSizes(theme)

  return (
    <>
      <div
        style={{
          fontSize: '1em',
          letterSpacing: 0.1,
          padding: '8px 24px',
          width: '100%',
          background: backgroundColor ? backgroundColor : themeV5.palette.error.main,// '#2f2f2f', dark grey
          color: themeV5.palette.white,
          textAlign: 'center',
          top: '0',
          lineHeight: '40px',
        }}>
        <ThemeProvider theme={theme}>
          {customChildren
            ? customChildren
            : (
              <Typography variant="body2">
                <WarningIcon
                  sx={{
                    paddingTop: '6.4px',
                    marginRight: '2px',
                    marginBottom: '-4px',
                  }}/>
                {text}
              </Typography>
            )}
        </ThemeProvider >
      </div>
    </>
  )
}

Ribbon.propTypes = {
  text: PropTypes.string,
  backgroundColor: PropTypes.string,
  customChildren: PropTypes.any,
}

export default Ribbon
